module.exports = __webpack_public_path__ + "static/media/hestia.fab14366.svg";